import { CheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Route, Routes } from 'react-router-dom';
import { createCheckoutSession } from './apis/resources/mobi-talk.api';
import MobiForSurePage from './pages/home/MobiForSurePage';
import MobiPage from './pages/home/MobiPage';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY, {
  developerTools: {
    assistant: {
      enabled: false,
    },
  },
  locale: 'en',
});
const App = () => {
  return (
    <CheckoutProvider
      stripe={stripePromise}
      options={{
        fetchClientSecret: () =>
          createCheckoutSession({
            returnUrl: `http://localhost:3005/mobi`,
          }),
        elementsOptions: { appearance: { theme: 'stripe' } },
      }}
    >
      <Routes>
        <Route path='/mobi' element={<MobiPage />} />
        <Route path='/mobi-for-sure' element={<MobiForSurePage />} />
      </Routes>
    </CheckoutProvider>
  );
};

export default App;
